import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, NumberInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';

import CanViewPrice from '../Helpers/CanViewPrice';

type Props = {
  index: number,
  item: string
};

const CreativeSettingsRtb = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field name={`${props.item}.competes`} source={`${props.item}.competes`} component={BooleanInput} label="RTB Competes" style={{ width: '150px' }} />
    <FormDataConsumer>
      {({ formData, ...rest }) => CanViewPrice(formData, props.index) &&
        <div>
          <Field name={`${props.item}.price`} source={`${props.item}.price`} component={NumberInput} label="Price ($)" /><br />
        </div>
      }
    </FormDataConsumer>
  </div>
);

export default CreativeSettingsRtb;



// WEBPACK FOOTER //
// ./src/views/Components/Campaigns/Site/Partials/CreativeSettingsRtb.tsx